import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { ApiPathsService } from "../../api-paths.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Permission } from 'src/app/Login/_guards/Permission';
import { CampoUtility } from 'src/app/shared/models/campo-aggiuntivo';
import { TaskService } from 'src/app/task/_service/task.service';




@Component({
    templateUrl: 'seriale.component.html',
    styleUrls: ['./seriale.component.scss']
})
export class SerialeComponent implements OnInit {
    @Output() refreshList = new EventEmitter<void>();
    seriale: any;
    campi: any = [
        {
            nome: 'Manutenzioni',
            oggetti: ['manutenzioniObject'],
            modificabile: true,
            type: 'table',
            class: "col-lg-12",
            tasktype: 'U',
            header: [
                { nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'date' },
                { nome: "Note", oggetti: ['note'], inputType: 'textarea' },
            ],
        },
    ];
    Azioni: any = [
        {
            nome: 'Manutenzione',
            close: true,
            icon: 'fas fa-plus text-info',
            class: ' btn ',
            labelClass: 'text-info font-weight-bold',
            type: 'addTask',
            taskType: 'U',
            hideif: { fieldnotexist: 'id' }
        },
    ];
    constructor(
        private activeModal: NgbActiveModal,
        private apiPaths: ApiPathsService,
        public permission: Permission,
        public campoUtility: CampoUtility,
        private taskService: TaskService
    ) { }
    ngOnInit() {
        this.Refresh();
    }

    closeModal() {
        this.activeModal.close();
        this.activeModal.dismiss();
    }

    Refresh() {
        if (this.seriale?.id)
            this.apiPaths.ClassicPost('/task/seriale/get', { id: this.seriale?.id }).subscribe(
                data => {
                    this.seriale = data.data;
                }
            )
    }

    save(chiudi: boolean = false) {
        if (!this.seriale?.id)
            this.apiPaths.ClassicPost('/task/seriale/add', this.seriale).subscribe(
                data => {
                    this.seriale = data;
                    this.refreshList.emit();
                    if (chiudi)
                        this.closeModal();
                }


            );
        else
            this.apiPaths.ClassicPost('/task/seriale/update', this.seriale).subscribe(
                data => {
                    this.refreshList.emit();
                    if (!chiudi)
                        this.Refresh();
                    else
                        this.closeModal();
                }

            );
    }


    customButton(selected, button) {
        this.seriale.type = "SERIALE";
        this.taskService.HandleTaskCustomButtonClick(this.seriale, button, false);
    }

    //Prodotto nome, Seriale, Data di acquisto, quantità e il tipo con il component instance, 
    // /task/seriale/add



}
